module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adc01"
    }
  }, [_c('p', {
    staticClass: "adCardHead"
  }, [_vm._v("ALSO BY ALEX SANCHEZ")]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The God Box")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Getting It")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rainbow Road")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rainbow High")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rainbow Boys")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So Hard to Say")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b9cdd5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416995050_adc01.vue
// module id = 60
// module chunks = 0